<template>
    <div class="img-class">
        <div class="img-class-text" @click="goIndex"><span class="iconfont icon-fanhui1"></span> 返回主页</div>
        <img :src="imgUrl"/>
    </div>
</template>

<script>
  export default {
    name: "browse",
    data () {
      return {
        imgUrl: '',
        id: ''
      }
    },
    mounted () {
      this.imgUrl = this.$route.query.imgurl
      this.id = this.$route.query.eid
    },
    methods: {
      goIndex () {
        this.$router.push('/?id=' + this.id)
      }
    }
  }
</script>

<style lang="scss" scoped>
.img-class{
    position: relative;
    background-color: #000000;
    min-height: 1000px;
    .img-class-text{
        font-size: 16px;
        color: #ffffff;
        padding-top: 20px;
        padding-left: 10px;
    }
    img{
        width: 100%;
        position: absolute;
        top: 8%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/photo/browse.vue